export default __webpack_public_path__ + "static/media/APOVOL 2 ‐ Made with Clipchamp.2e186524.mp3";